// FILES USED in other places too
const CODES = {
  EXT_CLICK: 'EXT_CLICK',
  HOME_CLICK: 'HOME_CLICK',
  HOME_CORONA_CLICK: 'HOME_CORONA_CLICK',
  HEADER_SITE_VISIT: 'HEADER_SITE_VISIT',
  HOME_DL_APPLE: 'HOME_DL_APPLE',
  HOME_DL_PLAY: 'HOME_DL_PLAY',
  FOOT_SOCIAL_TW: 'FOOT_SOCIAL_TW',
  FOOT_SOCIAL_FB: 'FOOT_SOCIAL_FB',
  FOOT_SOCIAL_YT: 'FOOT_SOCIAL_YT',
  FOOT_ANTHEM_LINK: 'FOOT_ANTHEM_LINK',
  FOOT_PP_LINK: 'FOOT_PP_LINK',
  FOOT_LEGAL_LINK: 'FOOT_LEGAL_LINK',
  HOME_BOOKLET_OPEN: 'HOME_BOOKLET_OPEN',
  MENU_MEDICAL_BENIFITS: 'MENU_MEDICAL_BENIFITS',
  MENU_PHARMACY_BENIFITS: 'MENU_PHARMACY_BENIFITS',
  MENU_DENTAL_BENIFITS: 'MENU_DENTAL_BENIFITS',
  MENU_VISION_BENIFITS: 'MENU_VISION_BENIFITS',
  MENU_LND: 'MENU_LND',
  MENU_VSHB: 'MENU_VSHB',
  MENU_HOW_PW: 'MENU_HOW_PW',
  MENU_MEM: 'MENU_MEM',
  MENU_BD: 'MENU_BD',
  MENU_WELLNESS: 'MENU_WELLNESS',
  MENU_WT_GET_CARE: 'MENU_WT_GET_CARE',
  MENU_WELL_RES: 'MENU_WELL_RES',
  // MEDICAL
  MED_BFT_VIDEO: 'MED_BFT_VIDEO',
  MED_BFT_SUB: 'MED_BFT_SUB',
  MED_BFT_SEARCH_NETWORK: 'MED_BFT_SEARCH_NETWORK',
  MED_BFT_FIND_DOC: 'MED_BFT_FIND_DOC',
  MED_BFT_SIGN_UP: 'MED_BFT_SIGN_UP',
  MED_BFT_EN_BOOK: 'MED_BFT_EN_BOOK',

  // PHARMACY
  PH_BFT_SITE_BROWSE: 'PH_BFT_SITE_BROWSE',
  PH_BFT_DRUG_LIST: 'PH_BFT_DRUG_LIST',
  MR_ENROLL_MAT_LINK: 'MR_ENROLL_MAT_LINK',

  // DENTAL
  DN_BFT_MC_WEB: 'DN_BFT_MC_WEB',
  DN_BFT_TOOLS_WEB: 'DN_BFT_TOOLS_WEB',
  DN_BFT_HMO_WEB: 'DN_BFT_HMO_WEB',
  DN_BFT_HMO_VD: 'DN_BFT_HMO_VD',
  DN_BFT_APP: 'DN_BFT_APP',
  DN_BFT_PPO_WEB: 'DN_BFT_PPO',
  DN_BFT_PPO_VD: 'DN_BFT_PPO_VD',
  DN_FOOTER_HTN: 'DN_FOOTER_HTN',
  // BENEFIT DETAILS
  BD_MAT_LINK: 'BD_MAT_LINK',
  // MORE MAterials
  // VISION
  VN_BFT_AOA: 'VN_BFT_AOA',
  INTERNAL_MD: 'INTERNAL_MD',
  READY_TO_ENROLL: 'READY_TO_ENROLL',
  INTERNAL_HPW: 'INTERNAL_HPW',
  EBO_URL: 'EBO_URL',

  WELL_RES_WEB: 'WELL_RES_WEB',
  WTGC_WEB: 'WTGC_WEB',
  WTGC_FERT_APP: 'WTGC_FERT_APP',
  WTGC_FERT_APP_IOS: 'WTGC_FERT_APP_IOS',
  WTGC_LHO: 'LHO',
  WTGC_SSC: 'WTGC_SSC',
  WTGC_BCGC: 'WTGC_BCGC',
  WTGC_CRA: 'WTGC_CRA',
  WTGC_INC_DIA: 'WTGC_INC_DIA',

  MENU_CONTACT_US: 'MENU_CONTACT_US',
  MENU_FIND_PROVIDER: 'MENU_FIND_PROVIDER'
};

CODES.NAMES = {
  EXT_CLICK: 'Embedded Link',
  HOME_CLICK: 'Home button click',
  HOME_CORONA_CLICK: 'Corona Alert click',
  HEADER_SITE_VISIT: 'Brand Site Visit from header',
  HOME_DL_APPLE: 'Apple store from Home',
  HOME_DL_PLAY: 'Play store from Home',
  FOOT_SOCIAL_TW: 'Twitter click from home',
  FOOT_SOCIAL_FB: 'Facebook click from home',
  FOOT_SOCIAL_YT: 'Youtube click from home',
  FOOT_ANTHEM_LINK: 'Footer Anthem site link',
  FOOT_PP_LINK: 'Footer Privacy Policy Link',
  FOOT_LEGAL_LINK: 'Footer Legal link',
  HOME_BOOKLET_OPEN: 'Booklet open from home',
  MENU_MEDICAL_BENIFITS: 'Medical Benefits',
  MENU_PHARMACY_BENIFITS: 'Pharmacy Benefits',
  MENU_DENTAL_BENIFITS: 'Dental Benefits',
  MENU_VISION_BENIFITS: 'Vision Benifit',
  MENU_LND: 'Life and Disability',
  MENU_VSHB: 'Voluntary Supplemental Health Benefits',
  MENU_HOW_PW: 'How Your Health Plan Works',
  MENU_MEM: 'More Enrollment Materials',
  MENU_BD: 'Benefits Details',
  MENU_WT_GET_CARE: 'Where to get more care',
  MENU_WELL_RES: 'Wellness Resources',
  // MEDICAL
  MED_BFT_VIDEO: 'Medial Benefits basics VideoURL',

  MED_BFT_SEARCH_NETWORK: 'Medical Benefits doctor network',
  MED_BFT_FIND_DOC: 'Medical Benefits Find doctor',

  MED_BFT_EN_BOOK: 'Open Enrollment Booklet',

  // PHARMACY
  PH_BFT_SITE_BROWSE: 'Pharmacy Benefits site browse',
  PH_BFT_DRUG_LIST: 'Pharmacy Benefits drug list click',

  // DENTAL
  DN_BFT_MC_WEB: 'Dental Benifit site visit',
  DN_BFT_TOOLS_WEB: 'Dental Benifit site visit',
  DN_BFT_HMO_WEB: 'Dental Benifit site visit',
  DN_BFT_HMO_VD: 'HMO Video link',
  DN_BFT_APP: 'Dental Benifit app link',
  DN_BFT_PPO_WEB: 'Dental Benifit site visit',
  DN_BFT_PPO_VD: 'PPO Video',
  DN_FOOTER_HTN: 'Dental Benifit newsroom.heart.org',
  // BENEFIT DETAILS
  BD_MAT_LINK: 'Benefit details links',
  // MORE MAterials
  MR_ENROLL_MAT_LINK: 'More enrollment material link',
  // VISION
  VN_BFT_AOA: 'Vision Benefit aoa.org',
  INTERNAL_MD: 'Internal Browse to medical benifit ',
  READY_TO_ENROLL: 'Ready to enroll link',
  INTERNAL_HPW: 'Internal Browse to How plan works',
  EBO_URL: 'Brochure URL',

  WELL_RES_WEB: 'Wellness Resources web link',
  WTGC_WEB: 'Where To Get Care web',
  WTGC_FERT_APP_AND: 'Fertility Support app android',
  WTGC_FERT_APP_IOS: 'Fertility Support app IOS',
  WTGC_LHO: 'livehealthonline.com',
  WTGC_SSC: 'SmartShopper.com',
  WTGC_BCGC: 'bcbsglobalcore.com',
  WTGC_CRA: 'cancerresources.anthem.com',
  WTGC_INC_DIA: 'Diabetes link',
  MENU_VAINOUT: 'VA in out',
  MENU_CONTACT_US: 'Additional Information',
  MENU_FIND_PROVIDER: 'find a provider',
  MENU_WELLNESS: 'HEALTH AND WELLNESS',
};

CODES.GROUPS = [];
CODES.GROUPS['Medical Benefits'] = [CODES.MENU_MEDICAL_BENIFITS];
CODES.GROUPS['Pharmacy Benefits'] = [CODES.MENU_PHARMACY_BENIFITS];
CODES.GROUPS['Dental Benefits'] = [CODES.MENU_DENTAL_BENIFITS];
CODES.GROUPS['Vision Benefits'] = [CODES.MENU_VISION_BENIFITS];
CODES.GROUPS['Life and Disability'] = [CODES.MENU_LND];
CODES.GROUPS['Voluntary Supplemental Health Benefits'] = [CODES.MENU_VSHB];
CODES.GROUPS['How Your Health Plan Works'] = [CODES.MENU_HOW_PW];
CODES.GROUPS['More Enrollment Materials'] = [CODES.MENU_MEM];
CODES.GROUPS['Benefit Details'] = [CODES.MENU_BD];
CODES.GROUPS['Where To Get Care'] = [CODES.MENU_WT_GET_CARE];
CODES.GROUPS['Wellness Resources'] = [CODES.MENU_WELL_RES];
CODES.GROUPS['VA inout'] = [CODES.MENU_VAINOUT];

CODES.belongsToGroup = (act, k) => {
  if (CODES.GROUPS[k].indexOf(act) != -1) {
    return true;
  }

  return false;
};

CODES.TEMP = [];

CODES.ENGAGEMENT = [];

CODES.getReadableName = pcode => {
  try {
    return CODES.NAMES[pcode];
  } catch (err) {
    return 'ERR on Name';
  }
};

CODES.getGroupTotal = (sorted, code) => {
  let total = 0;
  _.each(sorted, a => {
    if (a.act.indexOf(code) != -1) {
      if (a.count > 0) {
        total += a.count;
      }
    }
  });
  return total;
};

export default CODES;
